var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.13292 14.2826C8.56505 14.2826 7.94642 14.028 7.4573 13.5389C6.63217 12.7129 6.4633 11.5535 7.0653 10.8412C7.22105 10.6575 7.49842 10.6339 7.6813 10.7896C7.86592 10.9454 7.88955 11.2219 7.7338 11.4065C7.43805 11.7565 7.59205 12.4355 8.0768 12.9202C8.5808 13.4251 9.2913 13.566 9.62467 13.2309C9.92742 12.929 9.82767 12.4407 9.31492 11.6961L9.2598 11.6156C8.4408 10.4265 8.3708 9.53486 9.00692 8.89961C9.34992 8.55661 9.85655 8.40698 10.3973 8.48223C10.8995 8.55486 11.3948 8.81211 11.792 9.21023C12.6172 10.0354 12.786 11.1956 12.184 11.907C12.0283 12.0925 11.7535 12.1152 11.5672 11.9586C11.3825 11.8029 11.3598 11.5264 11.5155 11.3417C11.8113 10.9917 11.6573 10.3127 11.1725 9.82886C10.6685 9.32573 9.95892 9.18398 9.62467 9.51823C9.32192 9.82011 9.42167 10.3084 9.9353 11.0547L9.99042 11.1352C10.8085 12.3217 10.8785 13.2134 10.2424 13.8495C9.95105 14.1417 9.55642 14.2826 9.13292 14.2826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.43625 14C7.32425 14 7.21225 13.9571 7.1265 13.8723C6.95588 13.7016 6.95588 13.4243 7.1265 13.2536L11.5015 8.87864C11.6721 8.70802 11.9495 8.70802 12.1201 8.87864C12.2908 9.04927 12.2908 9.32664 12.1201 9.49726L7.74513 13.8723C7.66025 13.9571 7.54825 14 7.43625 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.31223 21C8.20023 21 8.08823 20.9571 8.00248 20.8722L0.12748 12.9972C-0.0431445 12.8266 -0.0431445 12.5493 0.12748 12.3786L12.3775 0.128625C12.4597 0.046375 12.5709 0 12.6872 0H20.5622C20.8037 0 20.9997 0.196 20.9997 0.4375V8.3125C20.9997 8.42887 20.9534 8.54 20.872 8.62225L8.62198 20.8722C8.53623 20.9571 8.42423 21 8.31223 21ZM1.05586 12.6875L8.31223 19.9439L20.1247 8.13138V0.875H12.8684L1.05586 12.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.1875 7C14.9809 7 14 6.01825 14 4.8125C14 3.60675 14.9809 2.625 16.1875 2.625C17.3941 2.625 18.375 3.60675 18.375 4.8125C18.375 6.01825 17.3941 7 16.1875 7ZM16.1875 3.5C15.4639 3.5 14.875 4.08887 14.875 4.8125C14.875 5.53612 15.4639 6.125 16.1875 6.125C16.9111 6.125 17.5 5.53612 17.5 4.8125C17.5 4.08887 16.9111 3.5 16.1875 3.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.1ac50920bb651f8c47026c4fddb3a1f1.svg";
export { ForwardRef as ReactComponent };